module.exports = __webpack_public_path__ + "static/media/track_changes.b2fbc4de.svg";